RivalIQ.apps.Admin.module('models', function (models, Admin, Backbone, Marionette, $, _) {

    'use strict';

    models.TrackedPage = Backbone.Model.extend({
        url: '/admin/api/urls',

        parse: function (data) {
            if (_.isUndefined(data.is_primary)) {
                data.is_primary = false;
            }
            return data;
        }
    });
});
